import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import clsx from 'clsx'
import React, { useEffect, useRef, useState } from 'react'
import { Row } from 'react-table'

const groupCellStyles = makeStyles(() => ({
    keyBoardArrowIcon: {
        display: 'block',
        margin: 'auto',
    },
    hoverTooltipWrapper: {
        width: 'inherit',
    },
}))

const GroupedCellDefault = <TData extends Object>(
    canToggle: boolean,
    isProjectHome?: boolean
) => ({ row }: { row: Row<TData> }) => {
    const classes = groupCellStyles()
    const containerDivRef = useRef<HTMLDivElement | null>(null)
    const chevronRef = useRef<HTMLSpanElement | null>(null)
    const textRef = useRef<HTMLSpanElement | null>(null)
    const [overflowed, setOverflowed] = useState<boolean>(true)

    useEffect(() => {
        if (containerDivRef.current && chevronRef.current && textRef.current) {
            setOverflowed(
                textRef.current.offsetWidth + chevronRef.current.offsetWidth ===
                    containerDivRef.current.offsetWidth
            )
        }
    }, [containerDivRef, chevronRef, textRef])

    if (!row.canExpand) return null

    const groupedCell = row.allCells.find((d) => d.isGrouped)

    let toolTipText = isProjectHome
        ? `${groupedCell?.value} (${row.subRows.length})`
        : groupedCell?.value

    if ((groupedCell?.column as any)?.formattedText) {
        toolTipText = (groupedCell?.column as any)?.formattedText?.({
            value: groupedCell?.value,
        })
    }

    return (
        <Button
            {...row.getToggleRowExpandedProps({
                style: {
                    paddingLeft: `${row.depth * 2}rem`,
                    width: 'inherit',
                    display: 'flex',
                    justifyContent: 'flex-start',
                },
            })}
            disableFocusRipple
            disableRipple
            title={''}
            tabIndex={0}
            role={'button'}
        >
            <HoverTooltip
                text={overflowed ? toolTipText : ''}
                className={classes.hoverTooltipWrapper}
            >
                <div
                    style={{ display: 'flex', alignItems: 'center' }}
                    ref={containerDivRef}
                >
                    {canToggle && (
                        <span ref={chevronRef}>
                            {row.isExpanded ? (
                                <KeyboardArrowDownIcon
                                    data-testid={'expandedArrowIcon'}
                                    className={clsx(
                                        'arrow-down',
                                        classes.keyBoardArrowIcon
                                    )}
                                />
                            ) : (
                                <KeyboardArrowRightIcon
                                    data-testid={'collapsedArrowIcon'}
                                    className={clsx(
                                        'arrow-right',
                                        classes.keyBoardArrowIcon
                                    )}
                                />
                            )}
                        </span>
                    )}
                    <span
                        className="grouped-text"
                        ref={textRef}
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            fontWeight: 'normal',
                        }}
                    >
                        {toolTipText}
                    </span>
                </div>
            </HoverTooltip>
        </Button>
    )
}

export default GroupedCellDefault
